export const lineChartOptions = (
  title,
  subtitle,
  yAxisText,
  series,
  categories,
  xAxisText = ""
) => {

  return {
    chart: {
      type: "line"
    },
    title: {
      text: title,
      align: "center",
      style: {
        fontSize: "19px",
        fontWeight: "bold",
        color: "#333"
      }
    },
    subtitle: {
      text: subtitle,
      align: "left",
      style: {
        fontSize: "15px",
        margin: "10px"
      }
    },
    xAxis: {
      categories: categories,
      labels: {
        rotation: -45,
        style: {
          fontSize: "12px"
        }
      },
      title: {
        text: xAxisText,
        style: {
          fontSize: "16px",
          color: "#666"
        },
        margin: 20
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: yAxisText,
        style: {
          fontSize: "16px",
          color: "#666"
        },
        margin: 20
      },
      labels: {
        overflow: "justify",
        style: {
          fontSize: "14px",
          color: "#666"
        }
      },
      gridLineWidth: 0
    },
    tooltip: {
      valueSuffix: "",
      headerFormat: '<span style="font-size:16px">{point.key}</span><table>',
      pointFormat:
        '<td style="font-size:16px;padding:0">{point.datalabel}</td></tr>' 
         +
         '<td style="font-size:16px;padding:0">{point.key}</td></tr>'
        ,
      footerFormat: "</table>",
      shared: true,
      useHTML: true
    },
    plotOptions: {
      line: {
        marker: {
          enabled: true
        }
      }
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      floating: false,
      borderWidth: null,
      shadow: false,
      itemStyle: {
        fontSize: "14px"
      }
    },
    credits: {
      enabled: false
    },
    series: series
  };
};
